import React from 'react';
import Reflux from 'reflux';
import DialogFieldDateEditor from './DialogFieldDateEditor';
import DialogFieldStringEditor from './DialogFieldStringEditor';
import DialogFieldEnumEditor from './DialogFieldEnumEditor';
import DialogFieldBooleanEditor from './DialogFieldBooleanEditor';
import DialogFieldLongEditor from './DialogFieldLongEditor';
import DialogFieldDecimalEditor from './DialogFieldDecimalEditor';
import DialogFieldTimeEditor from './DialogFieldTimeEditor';
import DialogFieldLabel from './DialogFieldLabel';

export default class DialogFieldGroupForm extends React.Component
{
	constructor(props)
	{
		super(props);
		this.state = {fields:this.props.data.fields,layout:this.props.data.layout};
	}

	componentDidMount()
	{
		let maxWidth = 0;
		$(this.fieldGroupComponent).find(".fieldGroupLabel").each(
			function()
			{
				//alert($(this).width());
				if($(this).width()>maxWidth)
					maxWidth = $(this).width();
			}
		);
		
		$(this.fieldGroupComponent).find(".fieldGroupLabel").each(
			function()
			{
				$(this).width(maxWidth);
			}
		);	
	}

	getDialogFieldGroupComponents()
	{
		let result = [];
		if(this.state.fields)
		{
			for(let i = 0;i<this.state.fields.length;i++)
			{
				let field = this.state.fields[i];
				if(field.editorType == "TypeString")
				{
					result.push(
						<DialogFieldStringEditor data={field} dialogId = {this.props.dialogId}/>
					);
				}
				else if(field.editorType == "TypeEnum")
				{
					result.push(
						<DialogFieldEnumEditor data={field} dialogId = {this.props.dialogId}/>
					);
				}
				else if(field.editorType == "TypeBoolean")
				{
					result.push(
						<DialogFieldBooleanEditor data={field} dialogId={this.props.dialogId}/>
					);
				}
				else if(field.editorType == "TypeLabel")
				{
					result.push(
						<DialogFieldLabel data={field} dialogId={this.props.dialogId}/>
					);	
				}
				else if(field.editorType == "TypeLong")
				{
					result.push(
						<DialogFieldLongEditor data={field} dialogId={this.props.dialogId}/>
					);
				}
				else if(field.editorType == "TypeDecimal")
				{
					result.push(
						<DialogFieldDecimalEditor data={field} dialogId={this.props.dialogId}/>
					);
				}
				else if(field.editorType == "TypeTime")
				{
					result.push(
						<DialogFieldTimeEditor data={field} dialogId={this.props.dialogId}/>
					);
				}
				else
				{
					result.push(
						<DialogFieldDateEditor data={field} dialogId = {this.props.dialogId}/>
					);
				}
			}
		}
		return result;
	}

	render()
	{
		let components = this.getDialogFieldGroupComponents();
		let _style = {
			
		};
		if(this.state.layout=='horizontal'){
			_style = {display:'flex',flexDirection:'row'}
		}
		if(this.state.label)
		{
			return (
				<div className="box box-info" style={_style} ref={node => this.fieldGroupComponent = node} >
		            <div className="box-header with-border" style={{padding:'5px',textAlign:'center'}}>
		              <h4 className="box-title">{this.state.label}</h4>
		            </div>
				    {components}
	          	</div>
			);
		}
		else
		{
			_style.borderTop='0px';
			return (
				<div className="box box-info" style={_style} ref={node => this.fieldGroupComponent = node} >
				    {components}
	          	</div>
			);
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/dialog/DialogFieldGroupForm.js